module.exports = __webpack_public_path__ + "static/img/1.a46ab06.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/1.png
// module id = jClE
// module chunks = 0